<template>
  <div class="elementor-element elementor-element-37b38c71 e-flex e-con-boxed e-con e-parent" data-id="37b38c71"
    data-element_type="container"
    data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
    data-core-v316-plus="true">
    <div class="e-con-inner">
      <div class="elementor-element elementor-element-dbb46b e-con-full e-flex e-con e-child" data-id="dbb46b"
        data-element_type="container"
        data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
        <div class="elementor-element elementor-element-560a1c8e elementor-widget elementor-widget-image"
          data-id="560a1c8e" data-element_type="widget" data-widget_type="image.default">
          <div class="elementor-widget-container">
            <img loading="lazy" decoding="async" width="1080" height="1080"
              src="/wp-content/uploads/2024/02/secrity.png" class="attachment-full size-full wp-image-692" alt=""
              srcset="/wp-content/uploads/2024/02/secrity.png 1080w, /wp-content/uploads/2024/02/secrity-300x300.png 300w, /wp-content/uploads/2024/02/secrity-1024x1024.png 1024w, /wp-content/uploads/2024/02/secrity-150x150.png 150w, /wp-content/uploads/2024/02/secrity-768x768.png 768w"
              sizes="(max-width: 1080px) 100vw, 1080px" />
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-2376405e e-con-full e-flex e-con e-child" data-id="2376405e"
        data-element_type="container"
        data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
        <div class="elementor-element elementor-element-679e3aa9 elementor-widget elementor-widget-heading"
          data-id="679e3aa9" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">Security is our Priority</h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-7a3c2f6d elementor-widget elementor-widget-heading"
          data-id="7a3c2f6d" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">100% full (STP) Straight-Through
              Processing <br></h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-47e9683a elementor-widget elementor-widget-text-editor"
          data-id="47e9683a" data-element_type="widget" data-widget_type="text-editor.default">
          <div class="elementor-widget-container">
            <p>We take safety and security very seriously. Our commitment to 100% full Straight-Through
              Processing (STP) ensures that every trade is executed with maximum efficiency and transparency.
            </p>
            <p>In addition, all client funds are held in segregated accounts, which means your funds are always
              kept separate from our company's funds. This ensures that your funds are protected in the event of
              any unforeseen circumstances.</p>
          </div>
        </div>
        <div class="elementor-element elementor-element-12dcd26 elementor-widget elementor-widget-button"
          data-id="12dcd26" data-element_type="widget" data-widget_type="button.default">
          <div class="elementor-widget-container">
            <div class="elementor-button-wrapper">
              <router-link class="elementor-button elementor-button-link elementor-size-sm"
                :to="{ path: '/about', query: { tab: 'about' } }">
                <span class="elementor-button-content-wrapper">
                  <span class="elementor-button-text">See Our Story</span>
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingSecurity'
}
</script>